import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-navy font-sans text-steel antialiased" data-id="element-0" data-mp="3ikr002qv3a7b">
      <MetaPixel data-id="element-1" data-mp="3mkrdnl64zhdb" />
      <main data-id="element-2" data-mp="3mk8710lxsfel">
        <Hero data-id="element-3" data-mp="3mjztr7lwj82v" />
        <Testimonials data-id="element-4" data-mp="3mjga9mglsbmq" />
        <ProblemSection data-id="element-5" data-mp="3rc9hqi3ghy2i" />
        <SystemSection data-id="element-6" data-mp="3rbzo8kj7d8s2" />
        <ModulesSection data-id="element-7" data-mp="3rcsy3udgkeef" />
        <BonusSection data-id="element-8" data-mp="3recbnd7qcbci" />
        <UrgencySection data-id="element-9" data-mp="5ott78p769p" />
        <PricingSection data-id="element-10" data-mp="4wvvprmowg9" />
        <MoreResults data-id="element-11" data-mp="5ggxfcks0yi" />
        <GuaranteeSection data-id="element-12" data-mp="7sulgbavp5r" />
        <FAQ data-id="element-13" data-mp="2zllf11m4wkmq" />
        <ClosingSection data-id="element-14" data-mp="2zlv8x0aavbxp" />
        <SummaryTable data-id="element-15" data-mp="2zmo4d53t6f0j" />
        <FinalCta data-id="element-16" data-mp="2zn66ujh2dpgw" />
      </main>
      <Footer data-id="element-17" data-mp="33m5b01uz1i7a" />
      <PurchaseNotification data-id="element-18" data-mp="33lx0uhq8gqzs" />
    </div>;
}